(function ($) {
    function updatePaginationOffset() {
        document.querySelectorAll('.product-post-detail__slider').forEach((slider) => {
            const card = slider.querySelector('.product-post-detail__slide-card');
            if (!card) return;

            slider.style.setProperty('--slide-card-height', `${card.offsetHeight}px`);
        });
    }

    updatePaginationOffset();

    $(document).gp_ready(function () {
        updatePaginationOffset();
    });

    window.addEventListener('resize', updatePaginationOffset);

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(updatePaginationOffset);
    }
})(jQuery);